import React, { useMemo } from 'react'
import { connect } from 'react-redux'

import { FORMAT_DATE, NO_LIST, ORDER_MANAGER } from '../../../../helpers'
import { momentDateByLanguage } from '../../../../helpers/functions/booking'
import OrderItem from '../OrderItem'
import { CateringManagementStyle } from './styles'

function CateringManagement(props) {
  const { 
    bookingDetail,
    language,
    cateringList,
    equipmentList,
    selectedTab,
    orderManagerTab,
    handleOpenEditOrderModal,
    handleOpenCancelOrderModal,
  } = props

  const cateringDate = useMemo(() => {
    return momentDateByLanguage(bookingDetail.date, language, FORMAT_DATE.DATE_WITHOUT_DAY)
  }, [bookingDetail])

  const cateringEquipmentListSelector = useMemo(() => {
    if (selectedTab === orderManagerTab[ORDER_MANAGER.VALUE.CATERING].value) {
      return {
        orderList: cateringList,
        emptyListText: NO_LIST[language] + ORDER_MANAGER.TAB.CATERING[language] + (language === 'EN' ? ' List' : '')
      }
    } else if (selectedTab === orderManagerTab[ORDER_MANAGER.VALUE.EQUIPMENT].value) {
      return {
        orderList: equipmentList,
        emptyListText: NO_LIST[language] + ORDER_MANAGER.TAB.EQUIPMENT[language] + (language === 'EN' ? ' List' : '')
      }
    } else {
      return {  }
    }
  }, [selectedTab, bookingDetail])
  
  return (
    <CateringManagementStyle
      haveItemList={cateringEquipmentListSelector.orderList.length > 0}
    >
      <h1 className='catering-management__title'>
        {orderManagerTab[selectedTab].title[language]}
      </h1>

      <div className='catering-management__item-box'>
        { cateringEquipmentListSelector.orderList.length > 0
          ?
          cateringEquipmentListSelector.orderList.map((item, index) => {
            return (
              <React.Fragment key={item.orderId}>
                <OrderItem
                  selectedTab={selectedTab}
                  orderId={item.orderId}
                  cateringDate={cateringDate}
                  status={item.status}
                  bookingId={item.bookingId}
                  items={item.items}
                  orderNumber={item.orderNumber}
                  bookingDuration={bookingDetail.duration}
                  handleOpenEditOrderModal={handleOpenEditOrderModal}
                  handleOpenCancelOrderModal={handleOpenCancelOrderModal}
                />
                {(
                    cateringEquipmentListSelector.orderList.length > 0 &&
                    cateringEquipmentListSelector.orderList.length - 1 !== index
                  ) && <div className='catering-management__divider'/>
                }
              </React.Fragment>
            )
          })
          :
          <p>
            {cateringEquipmentListSelector.emptyListText}
          </p>
        }
      </div>
    </CateringManagementStyle>
  )
}

const mapStateToProps = ({ meetingReducer, accountReducer }) => {
  return {
    meetingReducer: meetingReducer,
    bookingDetail: meetingReducer.bookingDetail,
    cateringList: meetingReducer.cateringList,
    equipmentList: meetingReducer.equipmentList,
    language: accountReducer.language,
  }
}

export default connect(mapStateToProps, null)(CateringManagement)
